$(document).ready(function() {

  var buttons = document.getElementsByClassName('button');
  for(var i = 0; i < buttons.length; i++){
    buttons[i].href+=window.location.search;
  }

  //smooth scrolling
  $(".header__menu-item a").on("click", function (event) {
    event.preventDefault();
    var id = $(this).attr('href'),
        top = $(id).offset().top;
    $('body,html').animate({scrollTop: top - 100}, 600);
  });

  //countdown
  $('.banner__timer').countdown('2019/09/21', function(event) {
    var $this = $(this).html(event.strftime(''
        + '<p class="banner__timer-item"><span class="banner__timer-count">%D</span> дней</p> '
        + '<p class="banner__timer-item"><span class="banner__timer-count">%H</span> часов</p> '
        + '<p class="banner__timer-item"><span class="banner__timer-count">%M</span> минут</p> '
        + '<p class="banner__timer-item"><span class="banner__timer-count">%S</span> секунд</p> '));
  });

  //mobile menu
  $('.btn-menu').click(function () {
    $('.header').toggleClass('active')
    $('.btn-menu').toggleClass('active')
    $('.header__menu-item a').click(function () {
      $('.header').removeClass('active')
      $('.btn-menu').removeClass('active')
    })
  })

  //fixed menu
  var menu = $('.banner');
  var menuPosition;

  $(window).on('scroll', function () {
    var menuCoords = menu.offset();
    var windowScroll = $(this).scrollTop();
    if (!menuPosition) {
      menuPosition = menuCoords.top;
    }
    if (windowScroll > 0) {
      $('.header').addClass('scrolled')
    } else {
      menuPosition = false;
      $('.header').removeClass('scrolled')
    }
  });
  
})